/**
 * 俄语（ru-RU）
 */

export default {
  // 支付
  common: {
    default: 'Дефолт',
    delete: 'Удалить',
    cancel: 'Отмена',
    submit: 'Разместить',
    inputContent: 'Входной контент',
    selectContent: 'Выбрать контент',
    pleaseEnter: 'пожалуйста, введите',
    confirm: 'подтверждать',
    Warning: 'Предупреждение',
    success: 'Успех',
    next: 'следующий'
  },
  payment: {
    payment: 'Оплата',
    availableBalance: 'доступные средства',
    topUp: 'Пополнить',
    creditCard: 'Кредитная карта',
    settings: 'настройки',
    transactions: 'Сделки',
    paymentMethods: 'Способы оплаты',
    type: 'Тип',
    orderNumber: 'Номер заказа',
    amount: 'Количество',
    transactionTime: 'Время транзакции',
    allType: 'Все Типы',
    expenditure: 'Расходы',
    income: 'Доход',
    balance: 'Остаток средств',
    refund: 'Возвращать деньги',
    sample: 'Образец',
    purchase: 'Покупка',
    orderGoods: 'Заказать товары',
    cardNo: 'Карточка №',
    expireDate: 'Годен до',
    addCard: 'добавить кредитную карту',
    startDate: 'Дата начала',
    endDate: 'Дата окончания',
    export: 'Экспорт',
    enterAmount: 'Пожалуйста, введите сумму',
    dropshipping: 'дропшиппинг',
    recharge: 'перезарядка',
    orderDeposit: 'заказ депозита',
    orderBalance: 'баланс заказа',
    systemTopup: 'наполнение системы',
    giftCard: 'подарочная карточка'
  },
  // 地址
  address: {
    address: 'Адрес',
    editTheAddress: 'редактировать адрес',
    setAsDefault: 'Установить по умолчанию',
    addAddress: 'Добавить адрес',
    fullName: 'Полное имя',
    phoneNumber: 'Номер телефона',
    streetAddressLine1: 'Улица 1',
    streetAddressLine2: 'Улица 2',
    city: 'Город',
    state: 'Состояние',
    provice: 'Provice',
    region: 'Область',
    country: 'Страна',
    zipCode: 'Почтовый Индекс',
    vat: 'НДС',
    setAsDefaultAddress: 'Установить как адрес по умолчанию',
    defaultAddress: 'адрес по умолчанию',
    stateProviceRegion: 'Государство / Провинция / Регион',
    deleteTip: 'Вы уверены, что удалили этот адрес?'
  },
  // 店铺
  store: {
    store: 'Магазин',
    stores: 'магазины',
    allStores: 'Все магазины',
    storeTips: 'После того, как ваш магазин будет добавлен, вы сможете публиковать десятки тысяч популярных товаров в своем магазине всего за несколько кликов. KakaClo позаботится обо всем остальном после размещения заказа в вашем магазине.',
    allowStoreBinding: 'Разрешить привязку к магазину',
    connectANewStore: 'Подключить новый магазин',
    authorized: 'Авторизованный',
    unauthorized: 'Неавторизованный',
    reauthorize: 'Повторно авторизовать',
    storeSettings: 'Настройки магазина',
    removeStoreTitle: 'Вы уверены, что хотите удалить этот магазин?',
    removeStoreTips: 'Если вы просто хотите прекратить синхронизацию данных магазина с нашей платформой и сохранить настройки магазина, вы можете деактивировать магазин вместо его удаления.',
    removeStoreTips1: 'После удаления хранилища следующие данные, связанные с хранилищем, также будут удалены и не могут быть восстановлены:',
    listings: 'Listings',
    OrdersOfstore: 'Заказы магазина.',
    removeTheStore: 'Удалить магазин',
    storeUrl: 'URL магазина',
    openStoreMsg: 'Поздравляю с активацией, вы получите заказ вашего привязанного магазина!',
    closeStoreAlert: 'Вы уверены, что хотите отключить магазин?',
    closeStoreTips: 'Вы не сможете получать заказы после отключения магазина',
    closeStoreMsg: 'Вы закрыли свой магазин, вы можете снова открыть его для приема заказов.',
    chooseStoreTip: 'Выберите платформу вашего магазина',
    addStoreTip: 'Введите ТОЛЬКО ',
    addStoreTip2: 'свой домен по умолчанию',
    shopifyTips: 'Войдите в свою учетную запись Shopify Admin, чтобы найти домен по умолчанию. ',
    shopifyTips1: 'www.Ваш-домен-по-умолчанию.myshopify.com',
    shoplazzaTips: 'Войдите в свою админку Shoplazza, чтобы найти домен по умолчанию.',
    shoplazzaTips1: 'www.Ваш-домен-по-умолчанию.shoplazza.com',
    shoplineTips: 'Войдите в свою админку Shopline, чтобы найти домен по умолчанию.',
    shoplineTips1: 'www.Ваш-домен-по-умолчанию.shopline.com',
    eg: 'например',
    addStoreVideoTip: 'Как подключить новый магазин'
  },
  // 店铺设置
  storeSetting: {
    storeStting: 'Настройки магазина',
    storeName: 'Название магазина',
    whetherToAuthorize: 'Стоит ли авторизовать',
    storeLink: 'Ссылка на магазин',
    taxRuleTitle: 'Сделать товар облагаемым налогом',
    taxRuleTip: 'Определяет, будет ли взиматься налог при продаже варианта продукта.',
    productRules: 'Правила продукта',
    productRuleTip: 'Выберите действие при изменении инвентаря предмета, связанного с артикулом вашего магазина..',
    dontDealWidth: 'Не занимайся',
    productRuleY: 'Обновить инвентарь SKU магазина автоматически',
    priceRules: 'Ценовые правила',
    storeCurrency: 'Валюта магазина',
    compareAtPrice: 'Сравнить по цене',
    price: 'Цена',
    originalPrice: 'Рекомендуемая цена',
    multiplier: 'Множитель',
    shipping: 'Стоимость доставки',
    orderRules: 'Правила заказа',
    orderRulesTip1: 'Когда поставщик доставки заказа магазина доставит товар, выберите действие.',
    orderRulesY: 'Автоматически загружать номер логистического заказа в магазин',
    orderRulesTip2: 'Когда ваш магазин получит новый ожидающий заказ, разместите его автоматически..',
    orderRulesTip2N: 'Не приобретается автоматически',
    orderRulesTip2Y: 'Покупка автоматически',
    save: 'спасти',
    selectCurrency: 'Выберите Валюту',
    productCost: 'Стоимость продукта'
  },

  // 注册身份
  signupUser: {
    questionTile: 'Как бы вы описали себя в модном бизнесе?',
    answer1: 'Я интернет-продавец',
    answer2: 'Я обычный продавец',
    answer3: 'Я многоканальный продавец',
    answer4: 'я инфлюенсер',
    answer5: 'я клиент',
    answer6: 'Другой'
  },
  // my information
  myInformation: {
    myInformation: 'Моя информация'
  }
}

